/**
 * Created by claudio iozzia on 10/07/2017.
 */
import {AcceptorOutputFn} from "../../../../models/acceptor/IAcceptor";
import {Utils} from "../../../../common/utils";
import {ISingleOutput} from "../../../../models/ISpec";
import {IAppSpec} from "../../../../Redux/selector.state";
import {Ic} from "../../../../models/common";
import {Acceptor_DcDc_798xBuckBoost} from "../../../POWER/dcdc/acceptor/dcdc_buck_boost_798x_acceptor";


export class Acceptor_DcLED_LEDBuckBoost extends Acceptor_DcDc_798xBuckBoost {

  constructor() {
    super(true);
  }

  protected acceptSingle_Buck_Vout: AcceptorOutputFn = (ic: Ic, spec: IAppSpec, out: ISingleOutput<number>): boolean => {
    const _vin = spec.spec.value.input;
    const _out = spec.spec.value.output.outputs[0];
    const res = Utils.isValueEmpty(_out.voltage) || Utils.isValueEmpty(_vin.max) || out.voltage + _vin.max < ic.vout_max;
    // console.log("Acceptor_DcLED_LEDBuckBoost test RES", res, _out.voltage, _vin.max, out.voltage + _vin.max < ic.vout_max);
    return res;
  }


}
